module.exports = __webpack_public_path__ + "static/img/icon-count.73663f39.png";